module.exports = __webpack_public_path__ + "media/assets/img/flags/ca-ES-fc5e9d9aca53943d585c88f863af9ef7.png";